"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinimumResultsForSearch = void 0;
var MinimumResultsForSearch = function (target) {
    return /** @class */ (function (_super) {
        __extends(MinimumResultsForSearch, _super);
        function MinimumResultsForSearch() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            _this.minimumResultsForSearch = _this.options.get('minimumResultsForSearch');
            if (_this.minimumResultsForSearch < 0) {
                _this.minimumResultsForSearch = Infinity;
            }
            return _this;
        }
        MinimumResultsForSearch.prototype.showSearch = function (params) {
            if (countResults(params.data.results) < this.minimumResultsForSearch) {
                return false;
            }
            // TODO: Maybe call super?
            return false;
        };
        return MinimumResultsForSearch;
    }(target));
};
exports.MinimumResultsForSearch = MinimumResultsForSearch;
function countResults(data) {
    var count = 0;
    for (var d = 0; d < data.length; d++) {
        var item = data[d];
        if (item.children) {
            count += countResults(item.children);
        }
        else {
            count++;
        }
    }
    return count;
}
//# sourceMappingURL=minimum-results-for-search.js.map